<template>
  <SingleSelect
    v-if="type === 'RadioButton'"
    ref="RadioButton"
    :form-detail-item="formDetailItem"
    :choice-limit="choiceLimit"
    :question-no="QuestionNo"
    :title="title"
    :img="img"
    :must="must"
    :must-alert-wording="mustAlertWording"
    :must-other-alert-wording="mustOtherAlertWording"
    :active="Active"
    @UpdateAnswer="UpdateAnswer"
  />
  <MutiSelect
    v-else-if="type === 'CheckBox'"
    ref="CheckBox"
    :form-detail-item="formDetailItem"
    :choice-limit="choiceLimit"
    :question-no="QuestionNo"
    :title="title"
    :img="img"
    :must="must"
    :must-alert-wording="mustAlertWording"
    :must-other-alert-wording="mustOtherAlertWording"
    :active="Active"
    @UpdateAnswer="UpdateAnswer"
  />
  <SequenceAnswer
    v-else-if="type === 'TextArea'"
    ref="TextArea"
    :question-no="QuestionNo"
    :title="title"
    :img="img"
    :must="must"
    :place-holder="placeHolder"
    :must-alert-wording="mustAlertWording"
    :active="Active"
    @UpdateAnswer="UpdateAnswer"
  />
  <SimpleAnswer
    v-else-if="type =='Input'"
    ref="Input"
    :question-no="QuestionNo"
    :title="title"
    :img="img"
    :must="must"
    :place-holder="placeHolder"
    :must-alert-wording="mustAlertWording"
    :active="Active"
    @UpdateAnswer="UpdateAnswer"
  />
  <GiveScore
    v-else-if="type =='Score'"
    ref="Score"
    :question-no="QuestionNo"
    :title="title"
    :img="img"
    :must="must"
    :active="Active"
    :must-alert-wording="mustAlertWording"
    :form-category-value-cnt="formCategoryValueCnt"
    @UpdateAnswer="UpdateAnswer"
  />
  <TextDescription
    v-else-if="type =='TextDescription'"
    ref="TextDescription"
    :question-no="QuestionNo"
    :description="description"
    :img="img"
    :must="must"
    :active="Active"
    :must-alert-wording="mustAlertWording"
    :form-category-value-cnt="formCategoryValueCnt"
    @UpdateAnswer="UpdateAnswer"
  />
</template>

<script>
import SingleSelect from '@/components/QuestionTamplate/SingleSelect.vue';
import MutiSelect from '@/components/QuestionTamplate/MutiSelect.vue';
import SequenceAnswer from '@/components/QuestionTamplate/SequenceAnswer.vue';
import SimpleAnswer from '@/components/QuestionTamplate/SimpleAnswer.vue';
import GiveScore from '@/components/QuestionTamplate/GiveScore.vue';
import TextDescription from '@/components/QuestionTamplate/TextDescription.vue';

export default {
  components: {
    SingleSelect,
    MutiSelect,
    SequenceAnswer,
    SimpleAnswer,
    TextDescription,
    GiveScore
  },
  props: {
    type: String,
    formDetailItem: Array,
    choiceLimit: Number,
    QuestionNo: Number,
    title: String,
    img: String,
    must: Boolean,
    mustAlertWording: String,
    mustOtherAlertWording: String,
    placeHolder: String,
    description: String,
    Active: Boolean,
    formCategoryValueCnt: Number
  },
  methods: {
    UpdateAnswer(QusetionNo, ItemNo, Answer, IsCompeleted) {
      return this.$emit('UpdateAnswer', QusetionNo, ItemNo, Answer, IsCompeleted);
    },
    Check() {
      let result = false;
      switch (this.type) {
        case 'RadioButton':
          result = this.$refs.RadioButton.Check();
          break;
        case 'CheckBox':
          result = this.$refs.CheckBox.Check();
          break;
        case 'Input':
          result = this.$refs.Input.Check();
          break;
        case 'TextArea':
          result = this.$refs.TextArea.Check();
          break;
        case 'Score':
          result = this.$refs.Score.Check();
          break;
        default:
          break;
      }
      return result;
    }
  }
};
</script>
